<template>
    <div class="p-5 grid grid-cols-1 md:grid-cols-2 justify-between items-center gap-4 border border-[#EAECF0] rounded-lg"
    v-bind="$attrs">
        <div class="text-[#101828] text-base font-semibold">
            <slot name="default" />
        </div>
        <div class="flex justify-end w-full set-field">
            <slot name="field"></slot>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.set-field>* {
    width: 100%;
}
</style>